// Printtex — déclencheurs du système de mouvement (proposition lot 29). Ne fait qu'ajouter des classes ;
// les durées et la courbe sont dans printtex-mouvement.css. Rien ne bloque l'action du client.
(function () {
  var rejouer = function (el, cls) { if (!el) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); };

  // 2. Photo qui change : quand une option (coloris, montant) change, la photo affichée fait un fondu court.
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('input[type="radio"][name], select[name]')) return;
    if (!e.target.closest('variant-radios, variant-selects, .product-form, product-info, .product__info')) return;
    setTimeout(function () {
      var photo = document.querySelector('.product__media-list .is-active img, .product__media-list .product__media img');
      rejouer(photo, 'mv-photo-change');
    }, 30);
  });

  // 3. Étape suivante du devis et messages de confirmation : fondu + 8 px à l'apparition.
  var observer = new MutationObserver(function (liste) {
    liste.forEach(function (m) {
      var el = m.target;
      if (m.attributeName === 'hidden' && !el.hidden && el.matches('[data-pd-etape], .pd__ok, .form__message, .form-status')) rejouer(el, 'mv-entree');
    });
  });
  document.querySelectorAll('[data-pd-etape], .pd__ok, .form__message, .form-status').forEach(function (el) { observer.observe(el, { attributes: true, attributeFilter: ['hidden'] }); });

  // 4. « Ajouté » : quand le panier confirme l'ajout (événement du thème), le bouton montre une coche 1,2 s.
  var coche = function (btn) {
    if (!btn) return;
    btn.classList.add('mv-ajoute');
    if (!btn.querySelector('.mv-coche')) { var c = document.createElement('span'); c.className = 'mv-coche'; c.setAttribute('aria-hidden', 'true'); c.textContent = '✓ Ajouté'; btn.appendChild(c); }
    btn.classList.add('is-ajoute'); setTimeout(function () { btn.classList.remove('is-ajoute'); }, 1200);
  };
  window.mvCoche = coche;
  if (window.theme && theme.pubsub && theme.pubsub.subscribe) {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (ev && ev.cart && !ev.cart.errors) {
        coche(document.querySelector('.product-form__submit'));
        // 5. Compteur du panier : le nouveau chiffre se pose.
        document.querySelectorAll('cart-count:not([hidden])').forEach(function (c) { rejouer(c, 'mv-compteur'); });
      }
    });
  }
})();


/* Lot 29 « whaou » (accord de Karim, 21/10) : rares, bien placés, transform et opacity seulement, mouvement réduit respecté. */
(function () {
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduit) return;
  // Chaque effet ne s'installe que sur les pages où il sert (cartes produit, fiche, accueil).
  var aCartes = !!document.querySelector('.product-card'), estFiche = document.body.classList.contains('template-product');

  // 6. Carte produit → fiche : on nomme la photo de la carte touchée juste avant de partir (un seul nom par page).
  if (aCartes) document.addEventListener('click', function (e) {
    var lien = e.target.closest('.product-card a[href*="/products/"]');
    if (!lien || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var carte = lien.closest('.product-card');
    var img = carte && (carte.querySelector('secondary-media .is-selected img') || carte.querySelector('.product-card__media img'));
    document.querySelectorAll('[style*="view-transition-name"]').forEach(function (x) { x.style.viewTransitionName = ''; });
    if (img) img.style.viewTransitionName = 'ptx-photo';
  }, true);
  window.addEventListener('pageshow', function () { document.querySelectorAll('.product-card img[style*="view-transition-name"]').forEach(function (x) { x.style.viewTransitionName = ''; }); });

  // 7. Étiquette de prix de l'accueil : une seule fois par visite.
  var tag = document.querySelector('.pa__tag');
  try { if (tag && !sessionStorage.getItem('mv-pose')) { tag.classList.add('mv-pose'); sessionStorage.setItem('mv-pose', '1'); } } catch (err) { /* stockage indisponible : pas d'animation */ }

  // 7 bis. Ligne des références qui défile (accueil) : pause tant que le doigt est posé dessus.
  document.querySelectorAll('[data-ptx-defile]').forEach(function (el) {
    var pause = function (v) { return function () { el.classList.toggle('is-pause', v); }; };
    el.addEventListener('touchstart', pause(true), { passive: true }); el.addEventListener('touchend', pause(false)); el.addEventListener('touchcancel', pause(false));
  });

  // 8. Vol vers le panier, sur toutes les fiches, quand le thème confirme l'ajout.
  var depart = null;
  if (estFiche) document.addEventListener('submit', function (e) {
    if (!e.target.closest || !e.target.closest('product-form, form[action*="/cart/add"]')) return;
    var ph = Array.prototype.find.call(document.querySelectorAll('.product__media img'), function (i) { var r = i.getBoundingClientRect(); return r.width > 80 && r.bottom > 0 && r.top < innerHeight; });
    depart = ph || null;
    // Panier en page : le formulaire part vers /cart ; le vol se joue pendant que la page suivante se charge (l'ajout lui-même ne change pas).
    if (depart) requestAnimationFrame(voler);
  }, true);
  function voler() {
    var cible = document.querySelector('.cart-drawer-button, a[href$="/cart"]');
    if (!depart || !cible) return;
    var a = depart.getBoundingClientRect(), b = cible.getBoundingClientRect(), t = Math.min(a.width, a.height, 160);
    if (b.width === 0) return;
    var v = document.createElement('div'); v.className = 'mv-vol'; v.style.width = v.style.height = t + 'px';
    v.innerHTML = '<img alt="" src="' + (depart.currentSrc || depart.src) + '">'; document.body.appendChild(v);
    var x0 = a.left + (a.width - t) / 2, y0 = a.top + (a.height - t) / 2, x1 = b.left + b.width / 2 - t / 2, y1 = b.top + b.height / 2 - t / 2;
    v.animate([
      { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(1)', opacity: 1 },
      { transform: 'translate(' + (x0 + (x1 - x0) * 0.55) + 'px,' + (Math.min(y0, y1) - 50) + 'px) scale(.6)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(.12)', opacity: 0.15 }
    ], { duration: 640, easing: 'cubic-bezier(0.45, 0, 0.25, 1)', fill: 'forwards' }).finished.then(function () { v.remove(); });
    depart = null;
  }
  if (window.theme && theme.pubsub && theme.pubsub.subscribe) {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (ev) { if (ev && ev.cart && !ev.cart.errors) voler(); });
  }

  // 9. Carte produit qui s'incline sous la souris (ordinateur seulement), retour en douceur.
  if (!aCartes || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var courante = null, rafi = 0, px = 0, py = 0;
  var appliquer = function () { rafi = 0; if (!courante) return; var r = courante.getBoundingClientRect(); var dx = (px - r.left) / r.width - 0.5, dy = (py - r.top) / r.height - 0.5; courante.style.setProperty('--mv-ry', (dx * 7).toFixed(2) + 'deg'); courante.style.setProperty('--mv-rx', (-dy * 6).toFixed(2) + 'deg'); };
  document.addEventListener('pointermove', function (e) {
    var c = e.target.closest && e.target.closest('.product-card');
    if (c !== courante) {
      if (courante) { courante.classList.add('mv-repos'); courante.style.setProperty('--mv-rx', '0deg'); courante.style.setProperty('--mv-ry', '0deg'); }
      courante = c; if (c) { c.classList.add('mv-incline'); c.classList.remove('mv-repos'); }
    }
    px = e.clientX; py = e.clientY; if (courante && !rafi) rafi = requestAnimationFrame(appliquer);
  }, { passive: true });
})();
